import React from 'react';
import CardQueue from '../card/CardQueue'


const MainLoading = () => {

    return(
        <div className="center-container-holder">
            <div className="centered-container">
                <div className="center-holder">
                    <CardQueue/>
                </div>
            </div>
        </div>
    )
};

export default MainLoading;